import Colors from '../../constants/Colors';
import isMobile from '../IsMobile';

export const getRangeBackground = (selected: boolean, comparing: boolean) => {
  if (comparing) return selected ? Colors.light.hereworksYellow500 : '#fff';
  return selected ? Colors.light.hereworksBlue500 : '#fff';
};

export const getRangeBorder = (selected: boolean, comparing: boolean) => {
  if (comparing) {
    return selected ? Colors.light.hereworksYellow500 : Colors.light.hereworksYellow300;
  }
  return selected ? Colors.light.hereworksBlue500 : Colors.light.hereworksBlue300;
};

export const getRangeTextColor = (selected: boolean, comparing: boolean) => {
  if (selected) return '#FFF';
  if (isMobile) return Colors.light.hereworksBlack600;
  return comparing ? Colors.light.hereworksBlack400 : Colors.light.hereworksBlue400;
};
